import { useLocation } from "react-router-dom";
import { getTabs } from "./header-tabs";
import { useRouter } from "src/routes/hooks";
import { ButtonBase, styled } from "@mui/material";
import { DropdownTabNav } from "./dropdownTabNav";

const TabButton = styled(ButtonBase)(({ theme }) => ({
  padding: theme.spacing(0.5, 1.5),
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 400,
  color: theme.palette.text.secondary,
  "&.active": {
    fontWeight: 600,
    color: "#333C47",
    backgroundColor: "#f1f7b5",
  },
  "&:not(.active):hover": {
    color: theme.palette.mode === "dark" ? theme.palette.common.white : "black",
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(145, 158, 171, 0.1)",
  },
}));

export const HeaderTabs = ({ currentPath, role }: { currentPath: string; role?: string }) => {
  const router = useRouter();
  const location = useLocation();

  const tabsObj = getTabs(role);
  const currentTabs = tabsObj[currentPath] || [];

  return (
    <div style={{ display: "flex", gap: 8 }}>
      {currentTabs
        .filter((tab: any) => !tab.type || tab.type !== "root")
        .map((tab: any) => {
          if (tab.dropdown && tab.options?.length) {
            return (
              <DropdownTabNav
                key={tab.path}
                label={tab.label}
                options={tab.options}
                router={router}
                location={location}
              />
            );
          }

          const isActive =
            location.pathname === (typeof tab.path === "function" ? tab.path({}) : tab.path);

          return (
            tab.label &&
            <TabButton
              key={tab.path}
              className={isActive ? "active" : ""}
              onClick={() =>
                router.push(typeof tab.path === "function" ? tab.path({}) : tab.path)
              }
            >
              {tab.label || tab.title}
            </TabButton>
          );
        })}
    </div>
  );
};